module.exports = __webpack_public_path__ + "static/media/medical-history-on.6e3ecf08.svg";